import {
  computed, unref, type Ref,
} from 'vue';
import { useI18n } from 'vue-i18n';
import type {
  LocationAsRelativeRaw, RouteLocationRaw,
} from 'vue-router';

// eslint-disable-next-line import/prefer-default-export
export function useLocation(to: Ref<RouteLocationRaw> | RouteLocationRaw): Ref<RouteLocationRaw> {
  const i18n = useI18n();

  return computed(() => {
    const realTo = unref(to);
    if (typeof realTo === 'string') return `/${unref(i18n.locale)}${realTo}`;
    if ('name' in realTo) {
      return {
        ...realTo,
        params: { ...(realTo as LocationAsRelativeRaw)?.params, locale: unref(i18n.locale) },
      };
    }
    return realTo;
  });
}
